module.exports = new __parcel__URL__("sla-empty-background.5e924dae.svg").toString();